import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaSteamSymbol, FaYoutube, FaTimes } from 'react-icons/fa';
import { formatXpLabel } from '../xp';

export function canLinkHallProfile(player) {
  const uid = String(player?.userId || player?.id || '');
  const name = player?.username || '';
  if (!name || name === 'Guest') return false;
  if (uid === 'guest' || uid.startsWith('steam-')) return false;
  return true;
}

export function profilePathFor(username, pathname) {
  if (!username) return null;
  const isAppMode = !(pathname || '').startsWith('/legacy');
  return `${isAppMode ? '/user' : '/legacy/user'}/${username}`;
}

const PlayerPopupHeader = ({
  username,
  steamId64,
  youtubeChannelId,
  xp,
  hallXp,
  hallSlug,
  onClose,
  canLinkProfile = true
}) => {
  const location = useLocation();
  const path = canLinkProfile ? profilePathFor(username, location.pathname) : null;
  const steamHref = steamId64
    ? `https://steamcommunity.com/profiles/${steamId64}`
    : null;
  const youtubeHref = youtubeChannelId
    ? `https://www.youtube.com/channel/${youtubeChannelId}`
    : null;
  const name = username || 'Guest';

  return (
    <div className="flex items-start justify-between mb-3 gap-2">
      <div className="min-w-0">
        <div className="flex items-center gap-2 min-w-0">
          {path ? (
            <Link
              to={path}
              onClick={onClose}
              className="font-semibold truncate text-white hover:underline"
            >
              {name}
            </Link>
          ) : (
            <div className="font-semibold truncate">{name}</div>
          )}
          {steamHref && (
            <a
              href={steamHref}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#66c0f4] hover:text-white flex-shrink-0"
              title="View Steam Profile"
              aria-label="View Steam Profile"
            >
              <FaSteamSymbol className="h-5 w-5" />
            </a>
          )}
          {youtubeHref && (
            <a
              href={youtubeHref}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#ff0000] hover:text-white flex-shrink-0"
              title="View YouTube Channel"
              aria-label="View YouTube Channel"
            >
              <FaYoutube className="h-5 w-5" />
            </a>
          )}
        </div>
        <div className="text-xs text-yellow-400 font-semibold mt-0.5">
          {formatXpLabel(typeof xp === 'number' ? xp : 0, hallXp, hallSlug)}
        </div>
      </div>
      <button
        type="button"
        onClick={onClose}
        className="text-gray-400 hover:text-white flex-shrink-0"
        aria-label="Close"
      >
        <FaTimes size={14} />
      </button>
    </div>
  );
};

export default PlayerPopupHeader;
